import * as yup from 'yup';

export function isValidUrl(url: string): boolean {
    const urlValidationSchema = yup.string().url();
    return urlValidationSchema.isValidSync(url);
}
